"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleProvider = void 0;
const React = require("react");
class StyleProvider extends React.Component {
    getChildContext() {
        return {
            insertCss: this.props.onInsertCss
        };
    }
    render() {
        return (React.createElement(React.Fragment, null, this.props.children));
    }
}
exports.StyleProvider = StyleProvider;
StyleProvider.childContextTypes = {
    insertCss: () => null
};
//# sourceMappingURL=StyleProvider.js.map